export default __webpack_public_path__ + "static/media/88_mobile.3aa39e07.jpg";